import { LanguageService } from 'services/languageService';

export interface IAteParents {
  regions: any;
  cities: any;
  vc: any;
}
export const setLastAteParams = (
  parents?: IAteParents,
  onlyRegions?: boolean
) => {
  const lang = LanguageService.getLanguage();
  const params: any = { lang };
  if (!parents) return params;

  const { cities, regions, vc } = parents;
  const allCities = cities && cities.find((item) => item.id === 'all');
  const allRegions = regions && regions.find((item) => item.id === 'all');

  if (cities.length && !onlyRegions) {
    if (allCities) {
      params['all_2'] = '1';
    } else {
      cities.forEach((item, index) => {
        params[`parent[${index}]`] = `${item.id}_${item.type}`;
      });
    }
  }

  if (onlyRegions || allCities || (regions.length && !cities.length)) {
    if (allRegions) {
      params['all_1'] = '1';
    } else {
      regions.forEach((item, index) => {
        params[`parent[${index}]`] = `${item.id}_${item.type}`;
      });
    }
  }

  return params;
};
